// extracted by mini-css-extract-plugin
export default {"modal":"EaF8LH","overlay":"eNoJgv","title":"vlVY5o","description":"VSVFJ4","buttons":"hlHtTD","button":"aMwptk"};